// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"750c860c","532":"0553a6bc","723":"7ae3d4a9","889":"a58b4fc8"}[chunkId] + ".chunk.css";
};